// submit.js
// Clean, professional submit button with analytics

import { useStore } from "./store";

export const SubmitButton = () => {
  const { nodes, edges } = useStore((state) => ({
    nodes: state.nodes,
    edges: state.edges,
  }));

  const handleSubmit = async () => {
    try {
      const button = document.querySelector("#submit-button");
      const originalText = button.textContent;
      button.textContent = "Analyzing...";
      button.disabled = true;
      button.style.opacity = "0.6";

      const response = await fetch("http://localhost:8000/pipelines/parse", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ nodes, edges }),
      });

      if (!response.ok) {
        throw new Error("Failed to analyze pipeline");
      }

      const result = await response.json();

      // Create modal overlay
      const overlay = document.createElement("div");
      overlay.id = "analysis-modal";
      overlay.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.4);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 10000;
        backdrop-filter: blur(4px);
      `;

      // Create modal content
      const modal = document.createElement("div");
      modal.style.cssText = `
        background: #ffffff;
        border-radius: 12px;
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
        width: 90%;
        max-width: 480px;
        padding: 0;
        animation: slideUp 0.2s ease-out;
      `;

      modal.innerHTML = `
        <style>
          @keyframes slideUp {
            from {
              opacity: 0;
              transform: translateY(20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        </style>
        <div style="
          padding: 24px;
          border-bottom: 1px solid #e2e8f0;
        ">
          <h2 style="
            margin: 0;
            font-size: 18px;
            font-weight: 600;
            color: #0f172a;
            letter-spacing: -0.01em;
          ">Pipeline Analysis</h2>
          <p style="
            margin: 6px 0 0 0;
            font-size: 14px;
            color: #64748b;
          ">Results from your pipeline validation</p>
        </div>
        
        <div style="padding: 24px;">
          <div style="
            display: grid;
            gap: 16px;
          ">
            <div style="
              display: flex;
              align-items: center;
              justify-content: space-between;
              padding: 16px;
              background: #f8fafc;
              border-radius: 8px;
              border: 1px solid #e2e8f0;
            ">
              <div>
                <div style="
                  font-size: 12px;
                  font-weight: 500;
                  color: #64748b;
                  text-transform: uppercase;
                  letter-spacing: 0.05em;
                  margin-bottom: 4px;
                ">Nodes</div>
                <div style="
                  font-size: 28px;
                  font-weight: 700;
                  color: #0f172a;
                ">${result.num_nodes}</div>
              </div>
              <div style="
                width: 48px;
                height: 48px;
                background: linear-gradient(135deg, #3b82f6, #2563eb);
                border-radius: 10px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 24px;
              ">📊</div>
            </div>

            <div style="
              display: flex;
              align-items: center;
              justify-content: space-between;
              padding: 16px;
              background: #f8fafc;
              border-radius: 8px;
              border: 1px solid #e2e8f0;
            ">
              <div>
                <div style="
                  font-size: 12px;
                  font-weight: 500;
                  color: #64748b;
                  text-transform: uppercase;
                  letter-spacing: 0.05em;
                  margin-bottom: 4px;
                ">Edges</div>
                <div style="
                  font-size: 28px;
                  font-weight: 700;
                  color: #0f172a;
                ">${result.num_edges}</div>
              </div>
              <div style="
                width: 48px;
                height: 48px;
                background: linear-gradient(135deg, #8b5cf6, #7c3aed);
                border-radius: 10px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 24px;
              ">🔗</div>
            </div>

            <div style="
              display: flex;
              align-items: center;
              justify-content: space-between;
              padding: 16px;
              background: ${result.is_dag ? "#f0fdf4" : "#fef2f2"};
              border-radius: 8px;
              border: 1px solid ${result.is_dag ? "#bbf7d0" : "#fecaca"};
            ">
              <div>
                <div style="
                  font-size: 12px;
                  font-weight: 500;
                  color: #64748b;
                  text-transform: uppercase;
                  letter-spacing: 0.05em;
                  margin-bottom: 4px;
                ">DAG Status</div>
                <div style="
                  font-size: 18px;
                  font-weight: 600;
                  color: ${result.is_dag ? "#16a34a" : "#dc2626"};
                ">${result.is_dag ? "Valid DAG" : "Contains Cycles"}</div>
              </div>
              <div style="
                width: 48px;
                height: 48px;
                background: ${
                  result.is_dag
                    ? "linear-gradient(135deg, #10b981, #059669)"
                    : "linear-gradient(135deg, #ef4444, #dc2626)"
                };
                border-radius: 10px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 24px;
              ">${result.is_dag ? "✓" : "✕"}</div>
            </div>
          </div>
        </div>

        <div style="
          padding: 16px 24px;
          background: #f8fafc;
          border-top: 1px solid #e2e8f0;
          border-radius: 0 0 12px 12px;
          display: flex;
          justify-content: flex-end;
        ">
          <button
            id="close-modal-btn"
            style="
              background: #0f172a;
              color: #ffffff;
              border: none;
              padding: 10px 20px;
              border-radius: 6px;
              font-size: 14px;
              font-weight: 500;
              cursor: pointer;
              transition: all 0.15s ease;
            "
            onmouseover="this.style.background='#1e293b'"
            onmouseout="this.style.background='#0f172a'"
          >
            Close
          </button>
        </div>
      `;

      overlay.appendChild(modal);
      document.body.appendChild(overlay);

      // Close functionality
      const closeButton = document.getElementById("close-modal-btn");
      const closeModal = () => {
        overlay.remove();
      };

      closeButton.addEventListener("click", closeModal);
      overlay.addEventListener("click", (e) => {
        if (e.target === overlay) closeModal();
      });

      // Restore button
      button.textContent = originalText;
      button.disabled = false;
      button.style.opacity = "1";
    } catch (error) {
      console.error("Error:", error);
      alert(`Error: ${error.message}`);

      const button = document.querySelector("#submit-button");
      button.textContent = "Analyze Pipeline";
      button.disabled = false;
      button.style.opacity = "1";
    }
  };

  const containerStyle = {
    padding: "20px 24px",
    background: "#ffffff",
    borderTop: "1px solid #e2e8f0",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  };

  const infoStyle = {
    fontSize: "13px",
    color: "#64748b",
  };

  const buttonStyle = {
    padding: "10px 24px",
    fontSize: "14px",
    fontWeight: "500",
    color: "#ffffff",
    background: "#0f172a",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    transition: "all 0.15s ease",
  };

  return (
    <div style={containerStyle}>
      <div style={infoStyle}>Ready to validate your pipeline</div>
      <button
        id="submit-button"
        type="submit"
        onClick={handleSubmit}
        style={buttonStyle}
        onMouseEnter={(e) => {
          e.target.style.background = "#1e293b";
        }}
        onMouseLeave={(e) => {
          e.target.style.background = "#0f172a";
        }}
      >
        Analyze Pipeline
      </button>
    </div>
  );
};
